<template>
  <div class="min-height">
    <div class="container review-rating">
      <div class="col-sm-12">
        <closeSVG @click.native="closePanel" class="close-btn" />
        <div class="col-sm-3 p-0">
          <div class="div1">
            <image-view :src="profileImage ? profileImage : '/images/default-user.png'" alt></image-view>
          </div>
          <div class="div2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <h4
                  v-if="data && data.rated_to_profile == 'doctor'"
                  dark
                  v-on="on"
                  class="text-capitalize"
                >Dr. {{userName}}</h4>
                <h4 v-else dark v-on="on">{{userName}}</h4>
              </template>
              <span v-if="data && data.rated_to_profile == 'doctor'">Dr. {{userName}}</span>
              <span v-else>{{userName}}</span>
            </v-tooltip>
            <!-- <p class="mb-0">Ambulance driver</p> -->
            <!-- <v-rating v-model="rating"></v-rating> -->
            <div class="rating-div">
              <div class="aw1">
                <div class="v-rating">
                  <span>
                    <starRating v-model="rating" :clickable="true" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-9">
          <form action>
            <div>
              <textarea
                name="Rating"
                class="form-control"
                placeholder="Your review here.."
                v-model="review"
              ></textarea>
              <div class="send-btn" type="button" @click="submitRatingReview()">
                <p>Send</p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import closeSVG from "@/SVG/crossSolid";
import { mapState, mapGetters } from "vuex";
import config from "@/config.js";
import starRating from "@/components/elements/starRating";
import Image from "@/components/elements/Image";
import { bus } from "@/main.js";
export default {
  components: {
    closeSVG,
    starRating,
    "image-view": Image
  },
  props: ["data"],
  data() {
    return {
      rating: 0,
      review: "",
      userName: "",
      profileImage: ""
    };
  },
  mounted() {
    if (this.data && this.data.sender) {
      this.getProfileDetails(this.data.sender);
    }
  },
  watch: {
    data: {
      handler(newVal) {
        if (newVal && newVal.sender) {
          this.getProfileDetails(newVal.sender);
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      userDetails: state => {
        return state.user.userDetails;
      },
      currentRole() {
        return this.$store.getters["user/CURRENT_ROLE"];
      }
    }),
    ...mapGetters({
      appointment_id: "user/Appointment_id"
    })
  },
  methods: {
    closePanel() {
      this.$emit("close");
    },
    submitRatingReview() {
      let obj = {};
      if (this.data.subject_type == "onlineconsultation") {
        obj.rated_to = this.data.sender;
        obj.rated_to_profile = this.data.rated_to_profile;
        obj.rated_by_profile = this.data.rated_by_profile;
        obj.rating = this.rating;
        obj.review = this.review;
        obj.subject_id = this.data.subject_id;
        obj.subject_type = this.data.subject_type;
      }
      if (this.data.subject_type == "appointment") {
        obj.rated_to_profile = this.data.rated_to_profile;
        obj.rated_by_profile = this.currentRole;
        obj.rating = this.rating;
        obj.review = this.review;
        obj.subject_id = this.data.subject_id;
        obj.subject_type = "appointment";
        obj.rated_to = this.data.rated_to;
      }
      // let obj = {
      //   center_id: "", // if rating give to center then use center_id else use rated_to
      //   rated_to_profile: this.data.sender_role, //role
      //   rated_by_profile: this.currentRole,
      //   rating: this.rating,
      //   review: this.review,
      //   appointment_id: this.appointment_id
      // };
      // this.currentRole == "doctor"
      //   ? (obj.appointment_type = "doctor-patient")
      //   : (obj.appointment_type = "patient-doctor");
      // if (this.data.role == "patient" || this.data.role == "doctor") {
      //   obj.rated_to = this.data.sender;
      // }
      this.$http.post(`${config.NEW_BASE_URL}api/v2/rating`, obj).then(res => {
        if (res.body.status) {
          this.rating = 0;
          this.review = "";
          this.$emit("close");
          this.$swal({
            title: `Thanks for feedback`,
            text: "Review Submitted",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Ok"
          });
          bus.$emit("REFRESH_REVIEWS_CARDS");
          bus.$emit("DOCTOR_PATIENT_APPOINTMENT");
        }
      });
    },
    getProfileDetails(id) {
      // let url = config.BASE_URL + "api/patient/profile-details/" + id;
      let url = config.NEW_BASE_URL + "api/v2/patient/profile-details/" + id;

      this.$http.get(url).then(response => {
        response = response.body;
        if (response.status) {
          if (response.data) {
            this.userName = response.data.data.full_name
              ? response.data.data.full_name
              : "";
            this.profileImage = response.data.data.profile_image;
          }
        }
      });
    }
  }
};
</script>
